import type {ElementType} from 'react';
import styles from './heading.module.css';

type Props = {
  readonly as?: ElementType;
};

export function ImageListHeading({as: As = 'p'}: Props) {
  return <As className={styles.heading}>すべての画像</As>;
}
